import { useState, useEffect } from "react";

function useCsrfPageNeedsReload(localStorageKey: string, htmlElStr: string) {
  const [shouldReload, setShouldReload] = useState(false);

  useEffect(() => {
    const htmlEl: HTMLInputElement = document.querySelector(
      htmlElStr,
    ) as HTMLInputElement;

    const shouldUserReloadPage = () => {
      if (!htmlEl) {
        return;
      }
      const localStorageToken = decodeURIComponent(
        localStorage.getItem(localStorageKey) ?? "",
      );
      const formToken = decodeURIComponent(htmlEl.value);

      if (localStorageToken !== formToken && !shouldReload) {
        setShouldReload(true);
      } else if (shouldReload) {
        setShouldReload(false);
      }
    };
    const interval = setInterval(shouldUserReloadPage, 1000);

    return () => {
      clearInterval(interval);
    };
    // https://react.dev/learn/reusing-logic-with-custom-hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return shouldReload;
}

export default useCsrfPageNeedsReload;
